import UnicusErrorsStore from "unicus-ui/module/errors/store";

const ErrorsStore = UnicusErrorsStore();

export default ErrorsStore;
